import type { Variation } from '@shared/types/types.ts';
import type { DefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';
import { getLayoutImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapLink } from '@tilelist/layouts/mapping/ProductLink.ts';
import { mapShortTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';

export type { DefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';

/**
 *
 *
 *
 *
 */
export type DefaultLayoutV3 = DefaultLayout & {
    readonly showMultipleSizes: boolean;
};

export function createDefaultLayout(
    variation: Variation,
    showTopInfos: boolean,
    showMultipleSizes: boolean,
): DefaultLayoutV3 {
    const patchedVariation: Variation = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
    };
    const { images, primaryImage } = getLayoutImages(variation);
    return {
        variation: patchedVariation,
        title: mapShortTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
        showMultipleSizes,
    };
}
